import type { IRouter } from '@aurelia/router';

function shouldPreserveDefaultNavigation(event: Event): boolean {
  return event instanceof MouseEvent
    && (event.defaultPrevented || event.button !== 0 || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey);
}

function normalizePath(path: string): string {
  if (path === '/') {
    return path;
  }

  return `/${path.replace(/^\/+/, '').replace(/\/+$/, '')}`;
}

export function loadFromRoot(router: IRouter, path: string) {
  return router.load(normalizePath(path), { context: null });
}

export function navigateFromRoot(router: IRouter, path: string, event?: Event) {
  if (event && shouldPreserveDefaultNavigation(event)) {
    return Promise.resolve(true);
  }

  event?.preventDefault();
  return loadFromRoot(router, path);
}
